import React, { useEffect, useRef, useState } from 'react';
import { API, graphqlOperation } from 'aws-amplify';
import { getConversationChatAssistant } from '../../../graphql/queries';
import { onChatAssistantResponse } from '../../../graphql/subscriptions';
import { observer } from "mobx-react";
import { useStore } from "../../../hooks";
import dayjs from 'dayjs';
import _ from "lodash";
import Message from '../../../pages/Chatbox/components/Message';

import {
    ChatContainer,
    ChatContent,
    ChatInputContainer,
    TypingIndicator,
    TypingDot
} from './ChatTab.styled';

import ChatInput from "../../../elements/input/ChatInput";

const ERROR_MESSAGE = {
    message: "Oops! Something went wrong. Please try again.",
    type: "received",
    time: dayjs().format('HH:mm')
};

const createSentMessage = (text) => ({
    message: text,
    type: "sent",
    time: dayjs().format('HH:mm')
});

const createReceivedMessage = (text) => ({
    message: text,
    type: "received",
    time: dayjs().format('HH:mm')
});

const ChatTab = observer(({ selectedAgent }) => {
    const { conversationsStore, authStore, agentsWidgetHistoryStore } = useStore();
    const [agentIsTyping, setAgentIsTyping] = useState(false);
    const [newMessage, setNewMessage] = useState('');
    const [showSpinner, setShowSpinner] = useState(false);
    const [messages, setMessages] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState();
    const [attachment, setAttachment] = useState('');
    const [agent_params, setAgent_params] = useState({
        message: "",
        campaign_id: "",
        campaign_version: "",
        agent: selectedAgent?.id || "",
    });
    const [conversationID, setConversationID] = useState("");
    const [isSendMessageClicked, setIsSendMessageClicked] = useState(false);
    const [isStreaming, setIsStreaming] = useState(false);
    const [subscription, setSubscription] = useState(null);
    const textAreaRef = useRef(null);
    const bottomRef = useRef(null);

    useEffect(() => {
        if (authStore.selectedAccount && authStore.selectedAccount.id) {
            setSelectedCustomer(authStore.selectedAccount.id);
            conversationsStore.setCustomerId(authStore.selectedAccount.id);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authStore.selectedAccount]);

    useEffect(() => {
        if (selectedAgent && selectedCustomer) {
            setAgent_params(prev => ({
                ...prev,
                agent: selectedAgent.id
            }));
        }

        return () => {
            if (subscription) {
                subscription.unsubscribe();
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedAgent, selectedCustomer]);

    useEffect(() => {
        if (agentsWidgetHistoryStore.lastConversationID) {
            setConversationID(agentsWidgetHistoryStore.lastConversationID);
            setMessages(agentsWidgetHistoryStore.messagesData);
        }
    }, [agentsWidgetHistoryStore.lastConversationID, agentsWidgetHistoryStore.messagesData]);

    const adjustTextAreaHeight = () => {
        if (textAreaRef.current) {
            const textArea = textAreaRef.current;
            textArea.style.height = "auto";
            const scrollHeight = textArea.scrollHeight;
            textArea.style.height = `${Math.min(scrollHeight, 125)}px`;
        }
    };

    useEffect(() => {
        adjustTextAreaHeight();
    }, [newMessage]);

    const handleCleanThread = () => {
        setMessages([]);
        setConversationID("");
        setNewMessage("");
        setIsSendMessageClicked(false);
        setIsStreaming(false);
        if (subscription) {
            subscription.unsubscribe();
            setSubscription(null);
        }
        conversationsStore.setThreadId("");
        conversationsStore.setRunId("");
    };

    const handleStopClick = () => {
        if (subscription && (conversationsStore.runId && conversationsStore.threadId)) {
            conversationsStore.stopResponse();
            subscription.unsubscribe();
            setSubscription(null);
            setIsStreaming(false);
            setAgentIsTyping(false);
            setIsSendMessageClicked(false);
        }
    };

    const handleSendMessage = async () => {
        if (newMessage.trim() === "") return;

        setIsSendMessageClicked(true);
        setNewMessage("");

        const params = {
            ...agent_params,
            message: newMessage,
            customer_id: selectedCustomer,
            conversation_id: conversationID,
            attachment
        };

        try {
            let openAiAnswer = null;
            let local_msgs = _.union(messages, []);

            let resultConversationOpenAi = null;
            try {
                // GraphQL removed - commented out
                // resultConversationOpenAi = await API.graphql({
                    // query: getConversationChatAssistant,
                    // variables: { input: params },
                    // authMode: 'AMAZON_COGNITO_USER_POOLS'
                // });

                if (!resultConversationOpenAi.errors?.length) {
                    setAgentIsTyping(true);

                    const apiResponse = resultConversationOpenAi.data.getConversationChatAssistant;
                    const parseResponseBody = (responseBody) => JSON.parse(responseBody);

                    local_msgs = _.union(local_msgs, [createSentMessage(newMessage)]);
                    let tmpMsg = "";
                    let initialMessages = [...local_msgs];
                    setMessages(local_msgs);

                    // GraphQL removed - commented out
                    // let assistantResponseSub = API.graphql({
                        // ...graphqlOperation(onChatAssistantResponse, { id: apiResponse.id }),
                        // authMode: 'AMAZON_COGNITO_USER_POOLS'
                    // }).subscribe({
                        // next: ({ value }) => {
                            // const subApiResponse = value.data.onChatAssistantResponse;
                            // const body = parseResponseBody(subApiResponse.body);
                            // conversationsStore.setThreadId(body.thread_id);
                            // conversationsStore.setRunId(body.run_id);
                            // setIsStreaming(true);
                            // openAiAnswer = body.answer;
                            // setShowSpinner(false);
                            // setAgentIsTyping(false);
                            // setSubscription(assistantResponseSub);
// 
                            // setConversationID(body.conversation_id);
// 
                            // agentsWidgetHistoryStore.setLastConversationID(body.conversation_id);
// 
                            // const conversationTitle = newMessage.length > 30
                                // ? newMessage.substring(0, 30) + "..."
                                // : newMessage;
// 
                            // agentsWidgetHistoryStore.addConversation({
                                // id: body.conversation_id,
                                // title: conversationTitle,
                                // last_modified: new Date().toISOString(),
                                // agent_id: selectedAgent.id
                            // });
// 
                            // if (subApiResponse.status === 'done' || subApiResponse.status === 'guardrail') {
                                // updating chat messages in store
                                // const updateMessages = [...initialMessages, createReceivedMessage(openAiAnswer)];
                                // agentsWidgetHistoryStore.clearMessagesData();
                                // updateMessages.forEach(message => {
                                    // agentsWidgetHistoryStore.messagesData.push({...message});
                                // });
// 
                                // setIsStreaming(false);
                                // setMessages(updateMessages);
                                // assistantResponseSub.unsubscribe();
                                // setSubscription(null);
                                // setIsSendMessageClicked(false);
                            // } else {
                                // tmpMsg += openAiAnswer;
                                // const updatedMessages = [...initialMessages, createReceivedMessage(tmpMsg)];
                                // setMessages(updatedMessages);
                            // }
                        // },
                        // error: (error) => {
                            // setShowSpinner(false);
                            // setAgentIsTyping(false);
                            // setIsSendMessageClicked(false);
                            // setIsStreaming(false);
                            // const errorWithCurrentTime = {
                                // ...ERROR_MESSAGE,
                                // time: dayjs().format('HH:mm')
                            // };
                            // local_msgs = _.union(local_msgs, [errorWithCurrentTime]);
                            // setMessages(local_msgs);
                        // }
                    // });
                }
            } catch (err) {
                setIsSendMessageClicked(false);
                setIsStreaming(false);
                const errorWithCurrentTime = {
                    ...ERROR_MESSAGE,
                    time: dayjs().format('HH:mm')
                };
                const newMessages = [...messages, errorWithCurrentTime];
                setMessages(newMessages);
            }
        } catch (error) {
            setIsSendMessageClicked(false);
            setIsStreaming(false);
        }
    };

    const handleFileUploaded = (fileUrl) => {
        if (fileUrl) {
            setAttachment(fileUrl);
        }
    };

    const handleTextAreaChange = (e) => {
        setNewMessage(e.target.value);

        const textAreaWrapper = textAreaRef.current;
        if (textAreaWrapper) {
            const textArea = textAreaWrapper.getElementsByTagName("textarea")[0];
            textArea.style.height = "auto";
            const scrollHeight = textArea.scrollHeight;
            const newHeight = (Math.max(48, scrollHeight)) - 24;
            textArea.style.height = `${newHeight}px`;
        }
    };

    useEffect(() => {
        if (messages.length > 0) {
            bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
        }
    }, [messages]);

    // Add this effect for proper scrolling on initial load
    useEffect(() => {
        if (bottomRef.current && messages.length > 0) {
            setTimeout(() => {
                bottomRef.current.scrollIntoView({ behavior: 'smooth' });
            }, 100);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <ChatContainer>
            <ChatContent id={"chat-content"}>
                {messages.map((message, index) => (
                    <div key={index} itemType={message.type}>
                        <Message
                            key={index}
                            messageItem={message}
                            selectedAgent={selectedAgent}
                        />
                    </div>
                ))}
                {agentIsTyping && (
                    <TypingIndicator>
                        <TypingDot />
                        <TypingDot />
                        <TypingDot />
                    </TypingIndicator>
                )}
                <div ref={bottomRef} />
            </ChatContent>
            <ChatInputContainer id={"test-chat-input"}>
                <ChatInput
                    onChange={handleTextAreaChange}
                    onKeyPress={(e) => {
                        if (e.key === 'Enter' && !e.shiftKey) {
                            e.preventDefault();
                            handleSendMessage(newMessage);
                        }
                    }}
                    showSpinner={showSpinner}
                    newMessage={newMessage}
                    handleSendMessage={handleSendMessage}
                    textAreaRef={textAreaRef}
                    placeholder="Type your message..."
                    disableSend={!newMessage.trim() || isSendMessageClicked}
                    stop={isStreaming}
                    onStopClick={handleStopClick}
                    onCleanThread={handleCleanThread}
                    customerId={selectedCustomer}
                    onFileUploaded={handleFileUploaded}
                    attachment={attachment}
                    setAttachment={setAttachment}
                />
            </ChatInputContainer>
        </ChatContainer>
    );
});

export default ChatTab;